(function() {
  'use strict';

  const LGPD_KEY = 'lgpd_cookie_consent';
  const OFFER_KEY = 'entry_offer_popup_closed';
  const OFFER_DELAY = 3000;
  const MAX_WAIT_TIME = 5000;
  const CHECK_INTERVAL = 100;
  const PRIVACY_WAIT_TIME = 8000;

  const body = document.body;
  let scrollPosition = 0;
  let couponModalShown = false;
  let customerPrivacyApi = null;

  function getElements() {
    return {
      lgpdModal: document.getElementById('ec-lgpd-modal'),
      offerModal: document.getElementById('ec-offer-modal'),
      couponModal: document.getElementById('ec-coupon-modal'),
      lgpdAcceptBtn: document.getElementById('ec-lgpd-accept'),
      lgpdRejectBtn: document.getElementById('ec-lgpd-reject'),
      offerCloseBtn: document.getElementById('ec-offer-close'),
      offerDeclineBtn: document.getElementById('ec-offer-decline'),
      offerForm: document.getElementById('ec-offer-form'),
      offerEmailInput: document.getElementById('ec-offer-email'),
      offerError: document.getElementById('ec-offer-error'),
      couponCloseBtn: document.getElementById('ec-coupon-close'),
      couponCode: document.getElementById('ec-coupon-code'),
      couponCopyBtn: document.getElementById('ec-coupon-copy'),
      couponMessage: document.getElementById('ec-coupon-message')
    };
  }

  function lockScroll() {
    scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    body.style.overflow = 'hidden';
    body.style.position = 'fixed';
    body.style.top = `-${scrollPosition}px`;
    body.style.width = '100%';
  }

  function unlockScroll() {
    body.style.overflow = '';
    body.style.position = '';
    body.style.top = '';
    body.style.width = '';
    window.scrollTo(0, scrollPosition);
  }

  function getLocalStorage(key) {
    try {
      return localStorage.getItem(key) === 'true';
    } catch (e) {
      return false;
    }
  }

  function setLocalStorage(key, value) {
    try {
      localStorage.setItem(key, value.toString());
    } catch (e) {
      console.error('Erro ao salvar no localStorage:', e);
    }
  }

  function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }

  function showLgpdModal() {
    const elements = getElements();
    if (elements.lgpdModal) {
      elements.lgpdModal.classList.add('active');
      elements.lgpdModal.setAttribute('aria-hidden', 'false');
      lockScroll();
      setTimeout(() => {
        if (elements.lgpdAcceptBtn) {
          elements.lgpdAcceptBtn.focus();
        }
      }, 100);
    }
  }

  function finalizeLgpdChoice(allowTracking) {
    const elements = getElements();
    if (elements.lgpdModal) {
      if (document.activeElement && elements.lgpdModal.contains(document.activeElement)) {
        document.activeElement.blur();
      }
      elements.lgpdModal.classList.remove('active');
      elements.lgpdModal.setAttribute('aria-hidden', 'true');
      unlockScroll();
      setLocalStorage(LGPD_KEY, true);

      if (allowTracking) {
        loadTrackingScripts();
      }

      setTimeout(() => {
        const offerClosed = getLocalStorage(OFFER_KEY);
        if (!offerClosed) {
          const currentElements = getElements();
          if (currentElements.offerModal) {
            showOfferModal();
          }
        }
      }, OFFER_DELAY);
    }
  }

  function buildAcceptConsent() {
    const consent = {
      analytics: true,
      marketing: true,
      preferences: true
    };

    if (customerPrivacyApi && typeof customerPrivacyApi.saleOfDataRegion === 'function' && customerPrivacyApi.saleOfDataRegion()) {
      consent.sale_of_data = true;
    }

    return consent;
  }

  function buildRejectConsent() {
    return {
      analytics: false,
      marketing: false,
      preferences: true
    };
  }

  function submitLgpdConsent(consent, allowTracking) {
    if (customerPrivacyApi && typeof customerPrivacyApi.setTrackingConsent === 'function') {
      customerPrivacyApi.setTrackingConsent(consent, function () {
        finalizeLgpdChoice(allowTracking);
      });
      return;
    }

    finalizeLgpdChoice(allowTracking);
  }

  function handleLgpdAccept() {
    submitLgpdConsent(buildAcceptConsent(), true);
  }

  function handleLgpdReject() {
    submitLgpdConsent(buildRejectConsent(), false);
  }

  function showOfferModal() {
    const elements = getElements();
    if (elements.offerModal) {
      const skeleton = elements.offerModal.querySelector('#ec-offer-skeleton');
      const wrapper = elements.offerModal.querySelector('#ec-offer-wrapper');
      
      if (skeleton) {
        skeleton.style.display = 'flex';
      }
      if (wrapper) {
        wrapper.style.display = 'none';
      }
      
      elements.offerModal.classList.add('active');
      elements.offerModal.setAttribute('aria-hidden', 'false');
      lockScroll();
      
      const images = elements.offerModal.querySelectorAll('img');
      if (images.length > 0) {
        let loadedCount = 0;
        images.forEach(img => {
          if (img.complete) {
            loadedCount++;
            if (loadedCount === images.length) {
              hideSkeleton();
            }
          } else {
            img.addEventListener('load', () => {
              loadedCount++;
              if (loadedCount === images.length) {
                hideSkeleton();
              }
            });
            img.addEventListener('error', () => {
              loadedCount++;
              if (loadedCount === images.length) {
                hideSkeleton();
              }
            });
          }
        });
        
        if (images.length === 0) {
          setTimeout(hideSkeleton, 500);
        }
      } else {
        setTimeout(hideSkeleton, 500);
      }
      
      setTimeout(() => {
        if (elements.offerEmailInput) {
          elements.offerEmailInput.focus();
        }
      }, 200);
    }
  }

  function hideSkeleton() {
    const elements = getElements();
    if (elements.offerModal) {
      const skeleton = elements.offerModal.querySelector('#ec-offer-skeleton');
      const wrapper = elements.offerModal.querySelector('#ec-offer-wrapper');
      
      if (skeleton) {
        skeleton.style.display = 'none';
      }
      if (wrapper) {
        wrapper.style.display = 'flex';
      }
    }
  }

  function hideOfferModal() {
    const elements = getElements();
    if (elements.offerModal) {
      if (document.activeElement && elements.offerModal.contains(document.activeElement)) {
        document.activeElement.blur();
      }
      elements.offerModal.classList.remove('active');
      elements.offerModal.setAttribute('aria-hidden', 'true');
      unlockScroll();
      setLocalStorage(OFFER_KEY, true);
    }
  }

  function showCouponModal() {
    if (couponModalShown) return;
    couponModalShown = true;
    
    const elements = getElements();
    if (elements.couponModal) {
      elements.couponModal.classList.add('active');
      elements.couponModal.setAttribute('aria-hidden', 'false');
      lockScroll();
    }
  }

  function hideCouponModal() {
    const elements = getElements();
    if (elements.couponModal) {
      if (document.activeElement && elements.couponModal.contains(document.activeElement)) {
        document.activeElement.blur();
      }
      elements.couponModal.classList.remove('active');
      elements.couponModal.setAttribute('aria-hidden', 'true');
      unlockScroll();
      couponModalShown = false;
    }
  }

  function copyCouponCode() {
    const elements = getElements();
    if (!elements.couponCode) return;

    const code = elements.couponCode.textContent.trim();
    
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(() => {
        showCouponMessage('Cupom copiado!');
        if (elements.couponCopyBtn) {
          const copyText = elements.couponCopyBtn.querySelector('.ec-coupon-copy-text');
          if (copyText) {
            const originalText = copyText.textContent;
            copyText.textContent = 'Copiado!';
            setTimeout(() => {
              copyText.textContent = originalText;
            }, 2000);
          }
        }
      }).catch(() => {
        fallbackCopyTextToClipboard(code);
      });
    } else {
      fallbackCopyTextToClipboard(code);
    }
  }

  function fallbackCopyTextToClipboard(text) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      document.execCommand('copy');
      showCouponMessage('Cupom copiado!');
      const elements = getElements();
      if (elements.couponCopyBtn) {
        const copyText = elements.couponCopyBtn.querySelector('.ec-coupon-copy-text');
        if (copyText) {
          const originalText = copyText.textContent;
          copyText.textContent = 'Copiado!';
          setTimeout(() => {
            copyText.textContent = originalText;
          }, 2000);
        }
      }
    } catch (err) {
      showCouponMessage('Erro ao copiar. Tente novamente.');
    }
    
    document.body.removeChild(textArea);
  }

  function showCouponMessage(message) {
    const elements = getElements();
    if (elements.couponMessage) {
      elements.couponMessage.textContent = message;
      setTimeout(() => {
        if (elements.couponMessage) {
          elements.couponMessage.textContent = '';
        }
      }, 3000);
    }
  }

  function trackingIsAllowed() {
    if (customerPrivacyApi) {
      return customerPrivacyApi.analyticsProcessingAllowed() || customerPrivacyApi.marketingAllowed();
    }

    return getLocalStorage(LGPD_KEY);
  }

  function loadTrackingScripts() {
    if (!trackingIsAllowed()) {
      return;
    }

    if (typeof window.loadTrackingScripts === 'function') {
      window.loadTrackingScripts();
    }
  }

  function shouldShowLgpdBanner() {
    if (getLocalStorage(LGPD_KEY)) {
      return false;
    }
    return true;
  }

  function waitForCustomerPrivacy(callback) {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      customerPrivacyApi = window.Shopify.customerPrivacy;
      callback(customerPrivacyApi);
      return;
    }

    let elapsed = 0;
    const privacyInterval = setInterval(function () {
      if (window.Shopify && window.Shopify.customerPrivacy) {
        clearInterval(privacyInterval);
        customerPrivacyApi = window.Shopify.customerPrivacy;
        callback(customerPrivacyApi);
        return;
      }

      elapsed += CHECK_INTERVAL;

      if (elapsed >= PRIVACY_WAIT_TIME) {
        clearInterval(privacyInterval);
        callback(null);
      }
    }, CHECK_INTERVAL);

    document.addEventListener('ecCustomerPrivacyReady', function () {
      if (window.Shopify && window.Shopify.customerPrivacy) {
        clearInterval(privacyInterval);
        customerPrivacyApi = window.Shopify.customerPrivacy;
        callback(customerPrivacyApi);
      }
    }, { once: true });
  }

  function bindConsentEvents() {
    document.addEventListener('visitorConsentCollected', function () {
      loadTrackingScripts();
    });

    document.addEventListener('trackingConsentAccepted', function () {
      loadTrackingScripts();
    });
  }

  function handleOfferFormSubmit(e) {
    e.preventDefault();
    const elements = getElements();
    
    if (!elements.offerEmailInput) return;
    
    const email = elements.offerEmailInput.value.trim();
    
    if (!email) {
      showOfferError('Por favor, insira seu e-mail');
      return;
    }

    if (!validateEmail(email)) {
      showOfferError('Por favor, insira um e-mail válido');
      return;
    }

    const form = elements.offerForm;
    if (!form) return;

    if (form.dataset.submitting === 'true') {
      return;
    }

    form.dataset.submitting = 'true';

    hideOfferError();
    
    const submitButton = form.querySelector('button[type="submit"]');
    let originalButtonText = '';
    if (submitButton) {
      originalButtonText = submitButton.textContent.trim();
      submitButton.setAttribute('data-original-text', originalButtonText);
      submitButton.disabled = true;
      submitButton.textContent = 'Enviando...';
    }

    let couponShown = false;

    const showCouponOnce = () => {
      if (couponShown) return;
      couponShown = true;
      if (document.activeElement && elements.offerModal && elements.offerModal.contains(document.activeElement)) {
        document.activeElement.blur();
      }
      hideOfferModal();
      setTimeout(() => {
        showCouponModal();
      }, 300);
    };

    const iframeId = 'ec-offer-form-iframe-' + Date.now();
    let iframe = document.getElementById(iframeId);
    
    if (!iframe) {
      iframe = document.createElement('iframe');
      iframe.id = iframeId;
      iframe.name = iframeId;
      iframe.style.display = 'none';
      iframe.style.width = '0';
      iframe.style.height = '0';
      iframe.style.border = 'none';
      iframe.style.position = 'absolute';
      iframe.style.left = '-9999px';
      document.body.appendChild(iframe);
    }

    const originalTarget = form.target;
    form.target = iframeId;
    
    const checkIframe = setInterval(() => {
      try {
        if (iframe.contentDocument && iframe.contentDocument.readyState === 'complete') {
          clearInterval(checkIframe);
          
          setTimeout(() => {
            try {
              const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
              const iframeBody = iframeDoc.body || iframeDoc.documentElement;
              const iframeHtml = iframeBody.innerHTML || iframeBody.outerHTML || iframeBody.textContent || '';
              const htmlLower = iframeHtml.toLowerCase();
              
              const hasSuccess = htmlLower.includes('success') || 
                                 htmlLower.includes('thank you') || 
                                 htmlLower.includes('obrigado') ||
                                 htmlLower.includes('subscribed') ||
                                 htmlLower.includes('inscrito') ||
                                 htmlLower.includes('email address has been') ||
                                 htmlLower.includes('email has been added');
              
              const hasError = (htmlLower.includes('error') && !htmlLower.includes('success')) ||
                              htmlLower.includes('already subscribed') ||
                              htmlLower.includes('já está inscrito') ||
                              htmlLower.includes('já é assinante') ||
                              htmlLower.includes('already a subscriber') ||
                              htmlLower.includes('invalid email') ||
                              htmlLower.includes('e-mail inválido') ||
                              htmlLower.includes('form__message') && !hasSuccess;
              
              if (hasError && !hasSuccess) {
                let errorText = 'Erro ao processar. Tente novamente.';
                
                if (htmlLower.includes('already subscribed') || 
                    htmlLower.includes('já está inscrito') || 
                    htmlLower.includes('já é assinante') ||
                    htmlLower.includes('already a subscriber')) {
                  errorText = 'Você já é assinante!';
                } else if (htmlLower.includes('invalid email') || htmlLower.includes('e-mail inválido')) {
                  errorText = 'Por favor, insira um e-mail válido.';
                }
                
                showOfferError(errorText);
                if (submitButton && originalButtonText) {
                  submitButton.disabled = false;
                  submitButton.textContent = originalButtonText;
                }
                if (iframe.parentNode) {
                  iframe.parentNode.removeChild(iframe);
                }
                form.target = originalTarget;
                return;
              }
              
              if (hasSuccess || !hasError) {
                showCouponOnce();
                if (iframe.parentNode) {
                  iframe.parentNode.removeChild(iframe);
                }
                form.target = originalTarget;
                form.dataset.submitting = 'false';
              } else {
                showOfferError('Erro ao processar. Tente novamente.');
                if (submitButton && originalButtonText) {
                  submitButton.disabled = false;
                  submitButton.textContent = originalButtonText;
                }
                if (iframe.parentNode) {
                  iframe.parentNode.removeChild(iframe);
                }
                form.target = originalTarget;
                form.dataset.submitting = 'false';
              }
            } catch (err) {
              console.error('Erro ao processar resposta:', err);
              showOfferError('Erro ao processar. Tente novamente.');
              if (submitButton && originalButtonText) {
                submitButton.disabled = false;
                submitButton.textContent = originalButtonText;
              }
              if (iframe.parentNode) {
                iframe.parentNode.removeChild(iframe);
              }
              form.target = originalTarget;
            }
          }, 500);
        }
      } catch (err) {
        clearInterval(checkIframe);
        console.error('Erro ao verificar iframe:', err);
        showOfferError('Erro ao processar. Tente novamente.');
        if (submitButton && originalButtonText) {
          submitButton.disabled = false;
          submitButton.textContent = originalButtonText;
        }
        if (iframe.parentNode) {
          iframe.parentNode.removeChild(iframe);
        }
        form.target = originalTarget;
        form.dataset.submitting = 'false';
      }
    }, 100);

    setTimeout(() => {
      if (couponShown) {
        clearInterval(checkIframe);
        return;
      }
      
      clearInterval(checkIframe);
      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      if (iframeDoc && iframeDoc.readyState === 'complete') {
        try {
          const iframeBody = iframeDoc.body || iframeDoc.documentElement;
          const iframeHtml = iframeBody.innerHTML || iframeBody.outerHTML || iframeBody.textContent || '';
          const htmlLower = iframeHtml.toLowerCase();
          
          const hasError = (htmlLower.includes('error') && !htmlLower.includes('success')) ||
                          htmlLower.includes('already subscribed') ||
                          htmlLower.includes('já está inscrito') ||
                          htmlLower.includes('já é assinante') ||
                          htmlLower.includes('already a subscriber');
          
          if (hasError) {
            const errorText = htmlLower.includes('already subscribed') || 
                            htmlLower.includes('já está inscrito') || 
                            htmlLower.includes('já é assinante') ||
                            htmlLower.includes('already a subscriber') 
                            ? 'Você já é assinante!' : 'Erro ao processar. Tente novamente.';
            showOfferError(errorText);
            if (submitButton && originalButtonText) {
              submitButton.disabled = false;
              submitButton.textContent = originalButtonText;
            }
            if (iframe.parentNode) {
              iframe.parentNode.removeChild(iframe);
            }
            form.target = originalTarget;
            form.dataset.submitting = 'false';
            return;
          }
        } catch (err) {
          console.error('Erro ao processar timeout:', err);
        }
      }
      
      if (!couponShown) {
        showCouponOnce();
      }
      
      if (iframe.parentNode) {
        iframe.parentNode.removeChild(iframe);
      }
      form.target = originalTarget;
      form.dataset.submitting = 'false';
    }, 5000);

    form.submit();
  }

  function showOfferError(message) {
    const elements = getElements();
    if (elements.offerError) {
      elements.offerError.textContent = message;
    }
  }

  function hideOfferError() {
    const elements = getElements();
    if (elements.offerError) {
      elements.offerError.textContent = '';
    }
  }

  function waitForElements(callback, maxWait = MAX_WAIT_TIME) {
    let elapsed = 0;
    const checkInterval = setInterval(() => {
      const elements = getElements();
      const lgpdExists = elements.lgpdModal !== null;
      const offerExists = elements.offerModal !== null;
      const couponExists = elements.couponModal !== null;
      
      if (elapsed >= maxWait || document.readyState === 'complete') {
        clearInterval(checkInterval);
        callback();
        return;
      }
      
      if (lgpdExists || offerExists || couponExists) {
        clearInterval(checkInterval);
        setTimeout(callback, 100);
        return;
      }
      
      elapsed += CHECK_INTERVAL;
    }, CHECK_INTERVAL);
  }

  function initModals() {
    const elements = getElements();
    const offerClosed = getLocalStorage(OFFER_KEY);

    try {
      const formSubmitted = sessionStorage.getItem('ec-offer-form-submitted');
      if (formSubmitted === 'true') {
        sessionStorage.removeItem('ec-offer-form-submitted');
        setTimeout(() => {
          showCouponModal();
        }, 500);
        return;
      }
    } catch (err) {
      console.error('Erro ao ler sessionStorage:', err);
    }

    if (shouldShowLgpdBanner() && elements.lgpdModal) {
      showLgpdModal();
      return;
    }

    loadTrackingScripts();

    if (!offerClosed && elements.offerModal) {
      setTimeout(() => {
        const currentElements = getElements();
        if (!getLocalStorage(OFFER_KEY) && currentElements.offerModal) {
          showOfferModal();
        }
      }, OFFER_DELAY);
    }
  }

  function attachEventListeners() {
    const elements = getElements();

    if (elements.lgpdAcceptBtn) {
      elements.lgpdAcceptBtn.addEventListener('click', handleLgpdAccept);
    }

    if (elements.lgpdRejectBtn) {
      elements.lgpdRejectBtn.addEventListener('click', handleLgpdReject);
    }

    if (elements.offerCloseBtn) {
      elements.offerCloseBtn.addEventListener('click', hideOfferModal);
    }

    if (elements.offerDeclineBtn) {
      elements.offerDeclineBtn.addEventListener('click', (e) => {
        e.preventDefault();
        hideOfferModal();
      });
    }

    if (elements.offerForm) {
      elements.offerForm.addEventListener('submit', handleOfferFormSubmit);
    }

    if (elements.offerEmailInput) {
      elements.offerEmailInput.addEventListener('input', () => {
        hideOfferError();
      });
    }

    if (elements.couponCloseBtn) {
      elements.couponCloseBtn.addEventListener('click', hideCouponModal);
    }

    if (elements.couponCopyBtn) {
      elements.couponCopyBtn.addEventListener('click', copyCouponCode);
    }
  }

  function initialize() {
    bindConsentEvents();

    waitForCustomerPrivacy(function () {
      waitForElements(function () {
        attachEventListeners();
        initModals();
      });
    });

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:block:select', function (event) {
        const block = event.target;
        if (block.querySelector('.ec-lgpd-modal') || block.classList.contains('ec-lgpd-modal')) {
          showLgpdModal();
        } else if (block.querySelector('.ec-offer-modal') || block.classList.contains('ec-offer-modal')) {
          showOfferModal();
        } else if (block.querySelector('.ec-coupon-modal') || block.classList.contains('ec-coupon-modal')) {
          showCouponModal();
        }
      });

      document.addEventListener('shopify:block:deselect', function (event) {
        const block = event.target;
        if (block.querySelector('.ec-lgpd-modal') || block.classList.contains('ec-lgpd-modal')) {
          const elements = getElements();
          if (elements.lgpdModal) {
            elements.lgpdModal.classList.remove('active');
            elements.lgpdModal.setAttribute('aria-hidden', 'true');
            unlockScroll();
          }
        } else if (block.querySelector('.ec-offer-modal') || block.classList.contains('ec-offer-modal')) {
          hideOfferModal();
        } else if (block.querySelector('.ec-coupon-modal') || block.classList.contains('ec-coupon-modal')) {
          hideCouponModal();
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  window.subscribeToNewsletter = window.subscribeToNewsletter || function (email) {}

  window.loadTrackingScripts = window.loadTrackingScripts || function () {}
})();
